import React, { memo, useState, useEffect } from "react";
import Header from "../Components/Header";
import PageTitleSection from "../Components/PageTitleSection";
import FooterSection from "../Components/FooterSection";
import HttpHelper from '../service/httpService'
import { handleImageError } from "../base/Utility";

const ServicesPages = () => {

    const [services, setServices] = useState([]);

    const getServices = async () => {
        await HttpHelper.get("website/GetServices").then((response) => {
            if (response.status === 200) {
                setServices(response.data);
            }
        }).catch((error) => {
            console.log(error);
        })
    }

    useEffect(() => {
        getServices();
    }, [])

    return (
        <>
            <Header />
            <PageTitleSection title="Services" pagetitle="Services" />

            <ul className="container pt--100 pb--80 col-md-8 mb-lg-40 mb-8 service-card">
                {
                    services && services.length > 0 ? services.map((service, index) => {
                        return (<>
                            <li className="{`container  row mb-5 service-box `}" key={index}>
                                <div className="col-md-4 align-item-vertical-center">
                                    <div className="portfolio-main-info">
                                        <div className="work-details-list mt-10 alignImages">
                                            <img className="resize-image" src={service.file && service.file.fileUrl} alt="No image found" onError={handleImageError} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 text-vertical-center-justified mt-3 mb-3">
                                    <h3 className="text-whitet">{service.title}</h3>

                                    <div dangerouslySetInnerHTML={{ __html: service.description }}></div>
                                </div>
                            </li>

                        </>)
                    }) : null
                }
            </ul>
            <FooterSection />
        </>
    )
}

export default memo(ServicesPages);